import { Libraries, useLoadScript } from "@react-google-maps/api";
import { getToken } from "firebase/app-check";
import { useEffect, useState } from "react";
import { appCheck } from "firebase-internal";
import { GOOGLE_MAPS_API_KEY } from "Utils/maps";

const libraries: Libraries = ["places"];

/**
 * Loads the Maps JS API. isLoaded waits until Maps requests carry App Check
 * tokens.
 */
export const useGoogleMapsScript = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const [isAppCheckReady, setIsAppCheckReady] = useState(false);

  useEffect(() => {
    if (!isLoaded) return;
    google.maps.Settings.getInstance().fetchAppCheckToken = () =>
      getToken(appCheck, false);
    setIsAppCheckReady(true);
  }, [isLoaded]);

  return { isLoaded: isLoaded && isAppCheckReady, loadError };
};
